import AutoComplete from "../../../material/autoComplete/AutoComplete";

const Hospital = ({ list, hospital, onInputChange }) => {
  return (
    <div className="flex flex-col justify-center items-start w-full gap-[10px] rounded-[6px] border-[#E2E2E4] border p-[9px_16px] mb-[10px]">
      <h1 className="text-[18px] 2sm:text-[16px] break-words whitespace-normal">เลือกโรงพยาบาล (แพทย์/เภสัช, เจ้าหน้าที่โรงพยาบาล และ โรงพยาบาล)</h1>
      <div className="flex flex-row md:flex-col w-full gap-2">
        <AutoComplete
          id={hospital}
          placeholder="โรงพยาบาลต้นสังกัด"
          list={list}
          callBack={(res) => {
            onInputChange("hospital_id", res?.id ?? "");
          }}
        />
      </div>
    </div>
  );
};
export default Hospital;
